export const formatVND = (n) => `${Math.round(Number(n) || 0).toLocaleString('vi-VN')} đ`;

/** Compact axis label in millions of VND, e.g. 12.500.000 -> '12,5 tr'. */
export const formatMillions = (n) => {
  const value = (Number(n) || 0) / 1e6;
  return `${value.toLocaleString('vi-VN', { maximumFractionDigits: 1 })} tr`;
};
